export function capitalizeFirstLetters(
  input: string | null | undefined,
): string {
  if (input) {
    return input
      .toLowerCase()
      .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
  }
  return "";
}
